// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"search_inputSearch__1RLgO","btnSearch":"search_btnSearch__1PLYn"};